import {
  BagUpsellRail,
  BagUpsellProductOption,
  BagUpsellModal,
  BagUpsellProductGrid,
} from './components';

export const BagUpsell = {
  Rail: BagUpsellRail,
  ProductOption: BagUpsellProductOption,
  Grid: BagUpsellProductGrid,
  Modal: BagUpsellModal,
};
